import React, { useEffect, useState } from "react";
import { message } from "antd";
import { useB2BContext } from "../../context/ContextB2B";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";
import "./OnDemandService.scss";
import { AppModal } from "../../components/common";

function OnDemandService() {
  const { paymentDetails, getUserByID } = useB2BContext();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isModalOpenReference, setIsModalOpenReference] = useState(false);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [packageData, setPackageData] = useState<any>();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [referenceId, setReferenceId] = useState<any>();
  const [getCompanyOndemandService, setGetCompanyOndemandServiceIQ] = useState<any>();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referenceId);
      setCopied(true);
      message.success("Copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleOkReference = () => setIsModalOpenReference(true);
  const handleCancelReference = () => setIsModalOpenReference(false);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);

  useEffect(() => {
    if (getUserByID) {
      authSVC
        .getMappedPackageList(getUserByID?.company_id?._id)
        .then((res: any) => setPackageData(res.data.package))
        .catch((err: any) => message.error(err.message));
    }
  }, [getUserByID]);

  useEffect(() => {
    if (selectedOption) {
      authSVC
        .GetCompanyOndemandService(getUserByID?.company_id?._id, selectedOption?._id)
        .then((res: any) => setGetCompanyOndemandServiceIQ(res?.data?.modules))
        .catch((err: any) => message.error(err.message));
    }
  }, [selectedOption, getUserByID]);

  const RequestOndemandServiceClick = (id: any) => {
    authSVC
      .RequestOndemandService({ service_id: id })
      .then((res: any) => {
        setReferenceId(res?.data?.data?.reference_id);
        setIsModalOpenReference(true);
      })
      .catch((err: any) => message.error(err.message));
  };

  return (
    <div className="ods-page">

      {/* ── Header ────────────────────────────────────────────── */}
      <div className="ods-page__header">
        <div>
          <h1 className="ods-page__title">On-Demand Services</h1>
          <p className="ods-page__subtitle">Request additional wellness services for your team.</p>
        </div>
      </div>

      {/* ── Plan switcher bar ─────────────────────────────────── */}
      <div
        className={`ods-page__plan-bar ${selectedOption ? "ods-page__plan-bar--selected" : ""}`}
        onClick={() => setIsModalOpen(true)}
        role="button"
        tabIndex={0}
      >
        <div className="ods-page__plan-bar-left">
          <span className="ods-page__plan-bar-tag">Subscription Plan</span>
          <strong className="ods-page__plan-bar-name">
            {selectedOption ? selectedOption?.package : "Select a plan to begin"}
          </strong>
        </div>
        <div className="ods-page__plan-bar-right">
          {packageData?.length !== 1 && (
            <span className="ods-page__switch-btn">
              Switch Plan
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          )}
        </div>
      </div>

      {/* ── Service modules ───────────────────────────────────── */}
      {!selectedOption ? (
        <div className="ods-page__empty">
          <div className="ods-page__empty-icon">🎯</div>
          <p>Select a subscription plan above to view available on-demand services.</p>
        </div>
      ) : !getCompanyOndemandService || getCompanyOndemandService.length === 0 ? (
        <div className="ods-page__empty">
          <div className="ods-page__empty-icon">📭</div>
          <p>No on-demand services available for this plan.</p>
        </div>
      ) : (
        <div className="ods-modules">
          {getCompanyOndemandService?.map((module: any, moduleIndex: any) => (
            <div key={moduleIndex} className="ods-module">
              <h2 className="ods-module__name">{module.moduleName}</h2>
              <div className="ods-module__items">
                {module?.moduleItem?.map((item: any) => (
                  <div key={item._id} className="ods-item">
                    <div className="ods-item__icon">⚡</div>
                    <span className="ods-item__label">{item.moduleName}</span>
                    <button
                      className="ods-item__request-btn"
                      onClick={() => RequestOndemandServiceClick(item._id)}
                    >
                      Request
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ── Plan chooser modal ────────────────────────────────── */}
      <AppModal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="ods-modal"
      >
        <div className="ods-modal__inner">
          <div className="ods-modal__icon-wrap">📦</div>
          <h3 className="ods-modal__heading">Choose a Plan</h3>
          <p className="ods-modal__desc">Select a subscription plan to view its on-demand services.</p>

          <div className="ods-modal__package-list">
            {packageData?.map((data: any, index: any) => (
              <button
                key={index}
                className={`ods-modal__package-item ${selectedOption?._id === data._id ? "ods-modal__package-item--active" : ""}`}
                onClick={() => {
                  setSelectedOption(data);
                  setIsModalOpen(false);
                }}
              >
                <div className="ods-modal__package-info">
                  <span className="ods-modal__package-index">Plan {index + 1}</span>
                  <strong className="ods-modal__package-name">{data.package}</strong>
                </div>
                <span className="ods-modal__package-cta">
                  On-Demand Services
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </button>
            ))}
          </div>
        </div>
      </AppModal>

      {/* ── Reference ID modal ───────────────────────────────── */}
      <AppModal
        open={isModalOpenReference}
        onOk={handleOkReference}
        onCancel={handleCancelReference}
        className="ods-modal"
      >
        <div className="ods-modal__inner">
          <div className="ods-modal__success-icon">✅</div>
          <h3 className="ods-modal__heading">Request Submitted!</h3>
          <p className="ods-modal__desc">
            Your request is being processed. Use the reference ID below to follow up.
          </p>

          <div className="ods-modal__ref-box">
            <span className="ods-modal__ref-label">Reference ID</span>
            <div className="ods-modal__ref-row">
              <code className="ods-modal__ref-id">{referenceId}</code>
              <button className="ods-modal__copy-btn" onClick={handleCopy}>
                {copied ? "✓ Copied" : "Copy"}
              </button>
            </div>
          </div>
        </div>
      </AppModal>
    </div>
  );
}

export default OnDemandService;